import { render } from "./set-remark.vue?vue&type=template&id=18aed26a"
import script from "./set-remark.vue?vue&type=script&lang=js"
export * from "./set-remark.vue?vue&type=script&lang=js"

import exportComponent from "/Users/wangdadan/IdeaProjects/LTCODE/后端管理web端/rent-admin-web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__